import React from "react";
import "./StrengthsSection.scss";
import { itx } from "../../../translationItx/itx";

interface Strength {
  icon: string;
  title: string;
  description: string;
}

const STRENGTHS: Strength[] = [
  {
    icon: "las la-border-all",
    title: itx("StrengthsSection.automatischegruppenadressen", "Automatische Gruppenadressen"),
    description: "",
  },
  {
    icon: "la-file-export", // no itx
    title: itx("StrengthsSection.etsExport&push", "ETS Export & ETS Push"),
    description: "",
  },
  {
    icon: "la-bolt", // no itx
    title: itx("StrengthsSection.schaltschrankplanung", "Schaltschrankplanung"),
    description: "",
  },
  {
    icon: "la-file-invoice", // no itx
    title: itx("StrengthsSection.raumbcherpflichtenhefte", "Raumbücher & Pflichtenhefte"),
    description: "",
  },
  {
    icon: "la-headset", // no itx
    title: itx("StrengthsSection.telefonsupport", "Telefon-Support"),
    description: "",
  },
];

export const StrengthsSection: React.FC = () => {
  return (
    <div className="strengths-section">
      {STRENGTHS.map((strength, index) => (
        <div key={index} className="strength-item">
          <div className="strength-icon">
            <i className={`la ${strength.icon} la-lg`} />
          </div>
          <div className="strength-content">
            <h3 className="strength-title">{strength.title}</h3>
          </div>
        </div>
      ))}
    </div>
  );
};
